/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- REPORT SETTINGS FORM : STYLES --------------- ++++++++++ */
export default theme => ({
    reportSettings: {
        padding: '16px 32px 32px 32px',
        background: 'white',
        borderRadius: pxToEm(5),
        '& .formelement': {
            border: themeV2.border.dropdown,
            borderRadius: themeV2.border.radius,
            padding: `0 ${themeV2.spacing[2]}`,
            marginTop: themeV2.spacing[2],
            marginRight: themeV2.spacing[2],
            height: pxToEm(55),
            display: 'flex',
            alignItems: 'center',
            minWidth: pxToEm(350),
            maxWidth: pxToEm(1000),
            background: themeV2.color.base.white,

            '& input.textfield': {
                border: 'none',
                padding: '0 10px',
                background: 'none',
                width: '100%',
                outline: 'none',
                fontSize: themeV2.typography.size.small.fontSize,
                color: themeV2.color.primary.main,
                fontWeight: '300',

                '&::placeholder': {
                    fontWeight: '500',
                    color: '#7E92B8',
                    fontFamily: "Work Sans",
                    fontSize: pxToEm(16),
                    fontStyle: "normal",
                    lineHeight: pxToEm(22),
},
            },
            '& .disabled': {
                pointerEvents: 'none',
                filter: 'grayscale(1)',
                opacity: 0.4,
            }
        },
        '& h3': {
            color: themeV2.color.primary.main,
            fontSize: pxToEm(16),
            fontWeight: 700,
            marginBottom: pxToEm(10),
        },
        '& label': {
            color: '#061240',
            fontSize: pxToEm(14),
            fontWeight: 400,
            marginBottom: pxToEm(10),
        },
        '& .compare': {
            height: 1,
            opacity: 0,
            pointerEvents: 'none'
        },
        '& > .sectiongroup:nth-child(2)': {
            marginTop: pxToEm(24),

        }

    },
    filter: {
        display: 'flex',
        flexWrap: 'nowrap',
        paddingRight: pxToEm(12),
        justifyContent: 'space-between',
        marginTop: themeV2.spacing[2],
        gap: pxToEm(12),
        '& .filter-site': {zIndex: '5',  maxWidth: '17em'},
        '& .filter-device': {zIndex: '4',  maxWidth: '15em',
            '& .divider': { margin: 0},
            '& .name-menuItems .items': {
                height: 'auto'
            }
        },
        '& .filter-country': {zIndex: '3',  maxWidth: '17em'},
        '& .datepickerdropdown': {
            zIndex: '2',
            background: 'white',
            marginLeft: pxToEm(-16),
            '& .name-dropdown': {
                left: 0,
                '& .toggle': {
                    marginTop: pxToEm(2),
                    maxWidth: 'none',
                    height: pxToEm(22),
                    '& .ball': {
                        height: pxToEm(18),
                        width: pxToEm(18)
                    }
                },
                '& .datepickerapply': {
                    '& .datepicker': {
                        '& .DayPicker': {
                            '& .DayPicker-Months': {
                                flexWrap: 'wrap',
                                justifyContent: 'space-around',
                            }
                        }
                    }
                }
            }
        },
        '& .singleselectdropdown': {
            zIndex: '10',
            height: pxToEm(55), 
            marginRight: pxToEm(16), 
            marginBottom: pxToEm(8) 
        }
    },
    errorText: {
        fontSize: pxToEm(14),
        color: themeV2.color.error.main,
        paddingTop: pxToEm(5),
    },
    dateInfo:{
        display: 'flex',
        padding: '12px 16px',
        alignItems: 'center',
        gap: pxToEm(16),
        alignSelf: 'stretch',
        borderRadius : pxToEm(12),
        background : '#E7ECF7',
        marginTop: pxToEm(8),
    },
    dateGroup: {
        gap: pxToEm(5),
    },
    infoGroup:{
        display: 'flex'
    },
    // wrap date dropdown when screen width small
    [`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(885)})`]: {
        filter: {
            flexWrap: 'wrap',
        }
    }
});
